import SEO from "@/components/SEO";
import PageHero from "@/components/sections/PageHero";
import CTASection from "@/components/sections/CTASection";
import { Reveal } from "@/components/motion/Reveal";
import { Btn, SectionHeading } from "@/components/primitives";
import { solutions, brand } from "@/content/site";
import {
  MapPin,
  MonitorSmartphone,
  Megaphone,
  Inbox,
  CalendarCheck,
  Bot,
  Star,
  RefreshCw,
} from "lucide-react";

const icons = [MapPin, MonitorSmartphone, Megaphone, Inbox, CalendarCheck, Bot, Star, RefreshCw];

export default function Solutions() {
  return (
    <>
      <SEO
        title="Trade Business Growth Solutions | Green Circle Group"
        description="Connect local visibility, advertising, lead capture, follow-up, reviews, CRM and automation with Green Circle Group's digital growth solutions for Australian trades."
        path="/solutions"
      />
      <PageHero
        eyebrow="Solutions"
        heading="The connected digital systems behind a growing trade business."
        copy="Green Circle Group brings local visibility, lead generation, customer follow-up and practical technology together. Engage us for the level of support your business needs today, with room to expand as the business grows."
        breadcrumbs={[
          { label: "Home", to: "/" },
          { label: "Solutions", to: "/solutions" },
        ]}
      >
        <Btn to="/contact">{`Book a Free Growth Assessment`}</Btn>
      </PageHero>

      <section className="bg-soft py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid md:grid-cols-2 gap-5">
            {solutions.map((s, i) => {
              const Icon = icons[i % icons.length];
              return (
                <Reveal
                  key={s.title}
                  delay={(i % 2) * 0.06}
                  className="rounded-[1.75rem] bg-white border border-border-neutral p-8 md:p-10 hover:border-mint transition-colors"
                >
                  <div className="flex items-start gap-5">
                    <div className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-forest text-lime">
                      <Icon className="h-7 w-7" />
                    </div>
                    <div>
                      <h2 className="text-xl md:text-2xl font-extrabold text-forest">
                        {s.title}
                      </h2>
                      <p className="mt-3 text-mid-neutral leading-relaxed">
                        {s.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal className="mt-14 rounded-[1.75rem] bg-forest text-white p-8 md:p-12 text-center">
            <SectionHeading dark>
              Not sure where your growth is leaking?
            </SectionHeading>
            <p className="mt-4 text-white/75 max-w-2xl mx-auto text-lg">
              The Growth Assessment shows which of these systems will move your
              business forward first.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
              <Btn to="/contact" size="lg">Book a Free Growth Assessment</Btn>
              <Btn to="/plans" variant="ghostLight" size="lg" withArrow>
                Compare Growth Plans
              </Btn>
            </div>
            <a
              href={`mailto:${brand.email}`}
              className="mt-6 inline-block text-mint font-semibold hover:text-lime"
            >
              {brand.email}
            </a>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
